import React from 'react';
import * as RadixTooltip from '@radix-ui/react-tooltip';
import clsx from 'clsx';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { TOOLTIP_DELAY_MS } from '@dashboard/components/ui/tooltip';

const Tooltip = ({
  label,
  children,
  side = 'top',
  align,
  open,
  delayDuration = TOOLTIP_DELAY_MS,
  triggerClassName,
  // The trigger is a <button>; a child that is itself interactive (a link,
  // another button) must become the trigger instead of nesting inside one.
  asChild = false,
}) => {
  if (!label) return children;

  return (
    <RadixTooltip.Provider delayDuration={delayDuration}>
      <RadixTooltip.Root open={open}>
        <RadixTooltip.Trigger className={triggerClassName} type="button" asChild={asChild}>
          {children}
        </RadixTooltip.Trigger>

        <RadixTooltip.Portal>
          <RadixTooltip.Content
            className={clsx(
              'data-[state=delayed-open]:data-[side=top]:animate-slideDownAndFade data-[state=delayed-open]:data-[side=right]:animate-slideLeftAndFade data-[state=delayed-open]:data-[side=left]:animate-slideRightAndFade data-[state=delayed-open]:data-[side=bottom]:animate-slideUpAndFade select-none leading-none will-change-[transform,opacity]',
              'inline-flex items-center rounded px-1.5 py-1.5 mx-2',
              'bg-black dark:bg-gray-800 shadow z-50',
            )}
            sideOffset={4}
            side={side}
            align={align}
          >
            <RadixTooltip.Arrow className="fill-current text-black dark:text-gray-800 mx-auto" />
            <span className="block text-sm text-white dark:text-gray-100 max-w-sm wrap-anywhere text-left">
              {label}
            </span>
          </RadixTooltip.Content>
        </RadixTooltip.Portal>
      </RadixTooltip.Root>
    </RadixTooltip.Provider>
  );
};

const InfoTooltip = ({ children, className }) => {
  return (
    <Tooltip label={children} triggerClassName={className}>
      <span type="button" className="inline-block align-sub ml-1">
        <InformationCircleIcon className="w-4 h-4 text-gray-600 dark:text-muted-foreground hover:text-gray-900 dark:hover:text-foreground transition-colors" />
      </span>
    </Tooltip>
  );
};

export { InfoTooltip };

export default Tooltip;
